import { EmployeeSearch } from '../../../types'

export function sortFullNameAndCompanyBySearchTerm(x: EmployeeSearch, y: EmployeeSearch, search: string, locale: string): number {
  const nameX = `${x.lastName} ${x.firstName}`.toLowerCase()
  const nameY = `${y.lastName} ${y.firstName}`.toLowerCase()

  const searchInNameX = nameX.includes(search)
  const searchInNameY = nameY.includes(search)
  const searchInCompanyX = x.companyName.toLowerCase().includes(search)
  const searchInCompanyY = y.companyName.toLowerCase().includes(search)

  if (searchInNameX && searchInNameY) {
    return nameX.localeCompare(nameY, locale)
  } else if (searchInNameX && !searchInNameY && searchInCompanyY) {
    return -1
  } else if (!searchInNameX && searchInCompanyX && searchInNameY) {
    return 1
  } else {
    return nameX.localeCompare(nameY, locale)
  }
}

export function updateLatestSearchResults(
  employee: EmployeeSearch,
  latestSearchResults: EmployeeSearch[],
  callback: (latestSearchResults: EmployeeSearch[]) => void,
): void {
  const employeeAlreadyInLatestSearchResults = latestSearchResults.some((result) => result.id === employee.id)
  if (!employeeAlreadyInLatestSearchResults) {
    const _latestSearchResults = latestSearchResults.length >= 5 ? latestSearchResults.slice(0, -1) : latestSearchResults
    callback([employee, ..._latestSearchResults])
  }
}
